import {
  fetchPlayerVersionsAction,
  unloadPlayerVersionsAction,
} from "cortex/ui/src/fleet/redux-store/ui-state/player-versions/actions";

import { fetchOptionFactory } from "./fetchOptionFactory";

export const PlayerVersionOptions = fetchOptionFactory(
  fetchPlayerVersionsAction,
  unloadPlayerVersionsAction,
);
